import { VipButtonText } from '../../common/constants'
const config = {
  buyVipUrl: 'https://www.jin10.com/vip_payment/index.html',
  vipText: {
    buy: VipButtonText.NORMAL,
    renewal: VipButtonText.VIP
  },
  defaultBg: require('assets/img/month/header_bg@2x.png'),
  menu: [{
      title: 'VIP预警',
      titleBg: 'VIP预警热榜',
      anchor: 'vipyrb',
      icon: require('assets/img/month/vipyj@2x.png'),
      bg: require('assets/img/month/vipyrb@2x.png')
    },
    {
      title: '人气报告',
      titleBg: '月度人气报告',
      anchor: 'ydrqbg',
      icon: require('assets/img/month/rqbg@2x.png'),
      bg: require('assets/img/month/ydrqbg@2x.png'),
    },
    {
      title: '人气视频',
      titleBg: '月度人气视频',
      anchor: 'ydrqsp',
      icon: require('assets/img/month/rqsp@2x.png'),
      bg: require('assets/img/month/ydrqsp@2x.png'),
    },
    {
      title: '口碑课程',
      titleBg: '口碑课程推荐',
      anchor: 'kbkctj',
      icon: require('assets/img/month/kbkc@2x.png'),
      bg: require('assets/img/month/kbkctj@2x.png'),
    },
    {
      title: '财经阅读',
      titleBg: '财经阅读风向标',
      anchor: 'cjydfxb',
      icon: require('assets/img/month/cjyd@2x.png'),
      bg: require('assets/img/month/cjydfxb@2x.png')
    }
  ],
  hot: [
    require('assets/img/month/hot1@2x.png'),
    require('assets/img/month/hot2@2x.png'),
    require('assets/img/month/hot3@2x.png'),
    require('assets/img/month/hot4@2x.png')
  ],
  titleBg: {
    vipyrb: require('assets/img/month/vipyrb@2x.png'),
    ydrqbg: require('assets/img/month/ydrqbg@2x.png'),
    ydrqsp: require('assets/img/month/ydrqsp@2x.png'),
    kbkctj: require('assets/img/month/kbkctj@2x.png'),
    cjydfxb: require('assets/img/month/cjydfxb@2x.png')
  },
  getKey(values) {
    if (!(values instanceof Object)) {
      return false
    }
    let list = []
    for (const key in values) {
      list.push(key)
    }
    return list
  }
}

const month1012 = {
  bg: require('assets/img/month/1012/header_bg@2x.png'),
  headerTitle: require('assets/img/month/1012/header_title@2x.png'),
  buyVipText: '开通vip',
  share: {
    title: 'xxx',
    desc: 'xxx',
    imgUrl: require('assets/img/week/share.png')
  },
  uploadAppStatics: {
    type: 'xxx',
    referer: 'xxx',
    source_type: 'news',
    id: 0
  }
}

const month1024 = {
  bg: require('assets/img/month/1024/header_bg@2x.png'),
  headerTitle: require('assets/img/month/1024/header_title@2x.png'),
  buyVipText: '开通vip',
  share: {
    title: '5月最高人气内容榜单',
    desc: '贵金属和原油反弹震荡，大跌后的美股也持续上扬，一片向好的市场中，哪些内容最受交易者关注？',
    imgUrl: require('assets/img/month/1024/share.png')
  },
  vipAppStatics: {
    type: '5月4周榜续费',
    referer: '5月4周榜续费',
    source_type: 'news',
    id: 1024
  },
  appStatics: {
    type: '5月4周榜升级',
    referer: '5月4周榜升级',
    source_type: 'news',
    id: 1024
  }
}

const month1051 = {
  bg: require('assets/img/month/1051/header_bg.png'),
  headerTitle: require('assets/img/month/1051/header_title.png'),
  buyVipText: '开通vip',
  share: {
    title: '黄金不断破前高，接下来要盯紧什么？',
    desc: '黄金气势汹汹续创八年新高，美元指数回落后反弹，6月投资者最为关注哪些内容？',
    imgUrl: require('assets/img/month/1051/share_logo.png')
  },
  vipAppStatics: {
    type: '6月4周榜续费',
    referer: '6月4周榜续费',
    source_type: 'news',
    id: 1051
  },
  appStatics: {
    type: '6月4周榜升级',
    referer: '6月4周榜升级',
    source_type: 'news',
    id: 1051
  }
}



export {
  config,
  month1012,
  month1024,
  month1051
}